"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("./../.");
class DQNEnv extends _1.Env {
}
exports.DQNEnv = DQNEnv;
//# sourceMappingURL=dqn-env.js.map